export type IGetImageForCropImageModal = (
  modal: IjQueryElmOrHtmlElm,
  triggerElm: IjQueryElmOrHtmlElm
) => void;

export function _getImageForCropImageModal(
  modal: IjQueryElmOrHtmlElm,
  triggerElm: IjQueryElmOrHtmlElm
): void {
  // Origin Elements
  const $button = $(triggerElm);
  const imageUrl = $button.data('href');
  const title = $button.data('modal-title');
  const cropRatio = $button.data('crop-ratio');
  const fileName = $button.data('modal-title');
  const input = $(`#${$button.data('input-name')}`) as JQuery<HTMLInputElement>;
  const input64 = $(`#${$button.data('input-name')}_base64`) as JQuery<HTMLInputElement>;
  // Modal Elements
  const $modal = $(modal) as IjQueryElm;
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalImgElm = $modal.find('.modal-body .full-image') as JQuery<HTMLImageElement>;
  const $modalLoading = $modal.find('.loading');
  const $imageContainer = $modal.find('.image-container');
  const $modalBody = $modal.find('.modal-body');
  const $cropImageButton = $modal.find('.crop-image-button');

  let imageWidth = $button.data('image-width');
  let imageHeight = $button.data('image-height');
  const maxWidth = 868;
  const maxHeight = 500;
  let ratio;

  // If image is too wide
  if (maxWidth < imageWidth) {
    ratio = maxWidth / imageWidth;
    imageWidth = maxWidth;
    imageHeight *= ratio;
  }
  // If image is too high
  if (maxHeight < imageHeight) {
    ratio = maxHeight / imageHeight;
    imageWidth *= ratio;
    imageHeight = maxHeight;
  }

  // Bind save / crop button
  $cropImageButton.off('click').on('click', function click() {
    if ($(this).hasClass('disabled')) {
      return;
    }
    // Execute cropping procedure
    window.DexeroCoreApp._cropImage(
      $modalBody,
      $cropImageButton,
      $modalImgElm,
      fileName,
      input,
      input64
    );
    // Close the modal cropping is done
    $modal.modal('hide');
  });

  // Once image is loaded we initiate cropper
  // CropRatio is calculated in FD by setting image width height options / no ratio if set to 0
  $modalImgElm.off('load').on('load', () => {
    ($modalImgElm as any).cropper({
      aspectRatio: cropRatio,
      minContainerHeight: imageHeight,
      minContainerWidth: imageWidth,
    });
    $modalLoading.addClass('hide').attr('aria-hidden', 'true');
    $imageContainer.removeClass('hide').attr('aria-hidden', 'false');
  });

  // Grab info from data-modal-title inside the a tag, to place in the modal title
  $modalTitle.text(title);

  $modalImgElm.attr({
    alt: title,
    src: imageUrl,
  });
}
